var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1359 9.97153H18.7176V7.13493C18.724 3.22348 15.544 0.0498047 11.6325 0.0498047C7.72106 0.0498047 4.54102 3.22348 4.54102 7.14129V9.97789H3.12273C1.56451 9.97789 0.286133 11.2563 0.286133 12.8145V26.9911C0.286133 28.5493 1.56451 29.8277 3.12273 29.8277H20.1359C21.6942 29.8277 22.9725 28.5493 22.9725 26.9911V12.8081C22.9725 11.2499 21.6942 9.97153 20.1359 9.97153ZM16.0273 9.97153H7.2377V7.13493C7.2377 4.71174 9.20932 2.74012 11.6325 2.74012C14.0557 2.74012 16.0273 4.71174 16.0273 7.13493V9.97153Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedLock);
export default __webpack_public_path__ + "static/media/closedLock.0294857ac11b40a6448a8f95ae4a8e84.svg";
export { ForwardRef as ReactComponent };